import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const CapabilitiesContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  padding: "1rem",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
}));

export const CapabilitiesHeader = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "12px",
}));

export const CapabilitiesIconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "37px",
  height: "37px",
  flexShrink: 0,
  borderRadius: "4px",
  backgroundColor: theme.palette.primary.main,
}));

export const CapabilitiesToggle = styled("button")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "8px",
  padding: 0,
  border: "none",
  background: "none",
  color: theme.palette.primary.main,
  cursor: "pointer",
  fontFamily: "inherit",
  fontSize: "14px",
  fontWeight: 700,
  textAlign: "left",
}));

export const CapabilitiesContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  paddingTop: "16px",
}));

export const CapabilitiesText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
  fontWeight: 400,
}));

export const CapabilitiesList = styled("ol")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  margin: 0,
  paddingLeft: "24px",
  color: theme.palette.text.primary,
  fontSize: "14px",
}));

export const CapabilitiesListItem = styled("li")(() => ({
  fontSize: "14px",
  fontWeight: 400,
}));
